import { render, staticRenderFns } from "./RecipeFormula.vue?vue&type=template&id=00e85e52&scoped=true"
import script from "./RecipeFormula.vue?vue&type=script&lang=ts"
export * from "./RecipeFormula.vue?vue&type=script&lang=ts"
import style0 from "./RecipeFormula.vue?vue&type=style&index=0&id=00e85e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e85e52",
  null
  
)

export default component.exports